import React from 'react';
import PropTypes from 'prop-types';

import {
  NotificationsNoneOutlined,
  ScheduleOutlined,
  TableChartOutlined
} from '@mui/icons-material';

import ChartReview from '../../../../Common/components/ChartReview';
import ReviewCard from '../../../../Common/components/ReviewCard';

import { reviewCardSx } from './styles';

const Review = ({ className }) => {
  const tabs = [
    {
      value: 0,
      label: 'Chart Review',
      icon: <TableChartOutlined />,
      content: <ChartReview />
    },
    {
      value: 1,
      label: 'Schedule',
      icon: <ScheduleOutlined />,
      content: null,
      disabled: true
    },
    {
      value: 2,
      label: 'Reminders',
      icon: <NotificationsNoneOutlined />,
      content: null,
      disabled: true
    }
  ];

  return (
    <ReviewCard
      className={className}
      tabs={tabs}
      defaultValue={0}
      cardStyles={reviewCardSx}
    />
  );
};

Review.propTypes = {
  className: PropTypes.string
};

export default Review;